import store from '@/store/store.js'
import { getToken } from '@/base/cookie'

class WebSocketServer {
  constructor (param) {
    this.websocket = null
    this.isConnect = false
    this.timeoutNum = null
    this.timeoutObj = null
    this.serverTimeoutObj = null
    this.timeout = 10000
    this.isActivelyClose = false
    this.url = process.env.VUE_APP_WEBSOCKET// 'ws://82.157.123.54:9010/ajaxchattest'//
    this.param = param
  }

  connect () {
    this.websocket = new WebSocket(this.url + '?X-Token=' + getToken() + '&cnoNo=' + store.state.user.seatsInfo.cnoThirdNo)
    this.initWebScoket(this.param)
  }

  initWebScoket (param) {
    this.isActivelyClose = false

    this.websocket.onopen = () => {
      // console.log('websocket已连接~ ')
      // 开始websocket心跳
      this.isConnect = true
      this.startWsHeartbeat()
    }

    this.websocket.onmessage = msg => {
      // 服务端发送来的消息存到vuex
      const pattern = /[{}]/im
      if (msg.data && pattern.test(msg.data) && JSON.parse(msg.data).status) {
        store.commit('SET_WEBSOCKETMSG', msg.data)
        console.log('接受消息:' + msg.data)
      }
    }

    this.websocket.onclose = e => {
      // console.log('websocket 断开: ' + e.code + ' ' + e.reason + ' ' + e.wasClean)
      this.isConnect = false
      // 如果手动关闭则不进行重连
      if (!this.isActivelyClose) {
        this.reconnectSocket(param)
      } else {
        clearTimeout(this.timeoutObj)
        clearTimeout(this.serverTimeoutObj)
      }
    }

    this.websocket.onerror = e => {
      this.isConnect = false
      if (!getToken()) return
      this.reconnectSocket(param)
    }
  }

  /**
     * websocket连接状态下才能进行send
     * @param {*} msg
     * 向服务send的消息
     */
  send (msg) {
    if (this.websocket.readyState === 1) {
      // 值为1，表示连接成功，可以通信了
      this.websocket.send(msg)
    }
  }

  close () {
    this.isActivelyClose = true
    if (this.websocket) {
      this.websocket.close()
    }
  }

  reconnectSocket (param) {
    if (this.isConnect === true) {
      return false
    }
    // console.log('websocket 重新连接~ ')
    this.isConnect = true
    this.timeoutNum && clearTimeout(this.timeoutNum)
    this.timeoutNum = setTimeout(() => {
      this.connect(param)
      this.isConnect = false
    }, 1000)
  }

  //  开启心跳
  startWsHeartbeat () {
    this.timeoutObj && clearTimeout(this.timeoutObj)
    this.serverTimeoutObj && clearTimeout(this.serverTimeoutObj)
    this.timeoutObj = setInterval(() => {
      this.send('123456789')
    }, this.timeout)
  }
}

export default WebSocketServer
